import JobMatchingSlider from '../Rules/JobMatchingSlider/JobMatchingSliderContainer';
import JobMatchingResults from '../Rules/JobPricingSummarySlider/JobPricingSummaryContainer';
import SalaryRangeSlideout from '../SalaryRangeSlideout/SalaryRangeContainer';
import YearOverYearContainer from '../YearOverYear/YearOverYearContainer';
import CopyMatchesContainer from '../GlobalJobMatching/CopyMatchesSlidout/CopyMatchesSlideout';
import SLUAgreementContainer from '../SurveyLibraryUpdate/Agreement/SLUAgreementContainer';
import CrowdSourcedMatch from '../CrowdSourcedMatch/CrowdSourcedMatch';
import MigrationSettingsSlideout from '../SurveyMigration/MigrationSettings/MigrationSettingsSlideout';
import StructureModelingAnalyticsSlideout from '../StructureModeling/StructureModelAnalytics/StructureModelingAnalyticsSlideout';
import StructureBulkCopySlideout from '../StructureModeling/StructureBulkCopy/StructureBulkCopySlideout';
import StructureBulkCreateSlideout from '../StructureModeling/StructureBulkCreate/StructureBulkCreateSlideout';
import SkillDifferentialSlideout from '../SkillGeoDifferential/SkillGeoDifferentialContainer';
import SurveyJobDataCuts from '../MarketPricing/SurveyJobDataCuts/SurveyJobDataCuts';
import JobDescriptionSlideout from '../MarketPricing/JobDescription/JobDescription';
import NotActiveSurveys from '../SurveyLibraryUpdate/NotActiveSurveys/NotActiveSurveys';
import MPMSlideout from '../MarketPricing/MarketplaceMatches/MarketplaceMatchesSlideouts/MPMSlideout';
import MarketplaceMatchesSlideoutNew from '../MarketPricing/MarketplaceMatches/MarketplaceMatchesSlideoutNew/MarketplaceMatchesSlideoutNew';
import MarketplaceMatchesSettings from '../MarketPricing/MarketplaceMatches/MarketplaceMatchesSlideouts/SettingsSlideout';
import MarketplaceMatchesSurveyDetails from '../MarketPricing/MarketplaceMatches/MarketplaceMatchesSlideouts/SurveyDetailsSlideout';
import MPMPurchase from '../MarketPricing/MarketplaceMatches/MarketplaceMatchesSlideouts/PurchaseSlideout';
import AddWidgetsSlideout from '../LandingDashboardPage/AddWidgetsSlideout/AddWidgetsSlideout';
import ConfigureViewContainer from '../MarketPricing/ConfigureView/ConfigureViewContainer';
import JobEmployeesContainer from '../MarketPricing/JobEmployees/JobEmployees';
import PrivateSurveyJobMatchContainer from '../MarketPricing/PrivateSurveyJobMatch/PrivateSurveyJobMatch';
import RegressionSurveyJobMatchContainer from '../MarketPricing/RegressionSurveyJobMatch/RegressionSurveyJobMatch';
import PrivateSurveyContainer from '../MarketPricing/PrivateSurveyJobMatch/PrivateSurvey/PrivateSurvey';
import JobDetailsContainer from '../MarketPricing/JobDetails/JobDetails';
import ParticipationReportSlideout from '../YearOverYear/ParticipationReportSlideout/ParticipationReportSlideout';

import {
  DIFFERENTIALS_PATH,
  YEAR_OVER_YEAR_PATH,
  LINK_HASH_COPY_MATCHES,
  LINK_HASH_JOB_MATCHING,
  LINK_HASH_JOB_MATCHING_RESULTS,
  LINK_HASH_SALARY_RANGE,
  LINK_HASH_SAVE_JOB_PRICING,
  LINK_HASH_SKILL_GEO_DIFFERENTIAL,
  LINK_HASH_SLU_AGREEMENT,
  LINK_HASH_STRUCTURE_MODEL_ANALYTICS,
  LINK_HASH_SURVEY_MIGRATION_SETTINGS,
  LINK_HASH_YEAR_OVER_YEAR,
  LINK_HASH_CROWD_SOURCED_MATCH,
  LINK_HASH_REMOVE_SURVEYS,
  LINK_HASH_MPM,
  LINK_HASH_CONFIGURE_VIEW,
  LINK_HASH_STRUC_BULK_COPY,
  LINK_HASH_STRUC_BULK_CREATE,
  LINK_HASH_MARKETPLACE_MATCHES_SETTINGS,
  LINK_HASH_MARKETPLACE_MATCHES_SURVEY_DETAILS,
  LINK_HASH_MPM_PURCHASE,
  LINK_HASH_ADD_WIDGETS,
  LINK_HASH_JOB_EMPLOYEES,
  LINK_HASH_PRIVATE_SURVEY_JOB_MATCH,
  LINK_HASH_PRIVATE_SURVEY,
  LINK_HASH_REGRESSION_SURVEY_JOB_MATCH,
  LINK_HASH_JOB_DETAILS,
  LINK_HASH_YOY_PARTICIPATION_REPORT
} from 'ps-components/Slideout/SlideoutAddresses';
import SaveJobPricingContainer from '../MarketPricing/Save/SaveJobPricingContainer';

export const SLIDEOUTS = {
  JOB_MATCHING_SLIDEOUT: {
    component: JobMatchingSlider,
    hash: LINK_HASH_JOB_MATCHING
  },
  JOB_MATCHING_RESULTS: {
    component: JobMatchingResults,
    hash: LINK_HASH_JOB_MATCHING_RESULTS
  },
  SALARY_RANGE_SLIDEOUT: {
    component: SalaryRangeSlideout,
    hash: LINK_HASH_SALARY_RANGE,
    containerClassName: 'assign-salary-range'
  },
  YEAR_OVER_YEAR: {
    component: YearOverYearContainer,
    hash: LINK_HASH_YEAR_OVER_YEAR,
    path: YEAR_OVER_YEAR_PATH,
    containerClassName: 'year-over-year__modal'
  },
  COPY_MATCHES_SLIDEOUT: {
    component: CopyMatchesContainer,
    hash: LINK_HASH_COPY_MATCHES,
    containerClassName: 'copy__matches-slideout'
  },
  SLU_AGREEMENT_SLIDEOUT: {
    component: SLUAgreementContainer,
    hash: LINK_HASH_SLU_AGREEMENT,
    containerClassName: 'slu-agreement'
  },
  CROWD_SOURCED_MARKET_PRICING: {
    component: CrowdSourcedMatch,
    containerClassName: 'crowd__sourced-slideout',
    hash: LINK_HASH_CROWD_SOURCED_MATCH
  },
  SURVEY_MIGRATION_SLIDEOUT: {
    component: MigrationSettingsSlideout,
    hash: LINK_HASH_SURVEY_MIGRATION_SETTINGS,
    containerClassName: 'survey-migration-settings'
  },
  SKILL_GEO_DIFFERENTIAL: {
    component: SkillDifferentialSlideout,
    hash: LINK_HASH_SKILL_GEO_DIFFERENTIAL,
    path: DIFFERENTIALS_PATH,
    containerClassName: 'skill-geo-differential'
  },
  STRUCTURE_MODELING_ANALYTICS_SLIDEOUT: {
    component: StructureModelingAnalyticsSlideout,
    hash: LINK_HASH_STRUCTURE_MODEL_ANALYTICS,
    containerClassName: 'structure-model-analytics'
  },
  SAVE_JOB_PRICING: {
    component: SaveJobPricingContainer,
    hash: LINK_HASH_SAVE_JOB_PRICING,
    containerClassName: 'save-job-pricing'
  },
  SURVEY_DATA_CUTS: {
    component: SurveyJobDataCuts,
    path: 'data-cuts',
    containerClassName: 'survey-data-cuts'
  },
  SURVEY_DATA_CUTS_SLIDEOUT: {
    component: SurveyJobDataCuts,
    containerClassName: 'survey-data-cuts'
  },
  JOB_DESCRIPTION_SLIDEOUT: {
    component: JobDescriptionSlideout,
    path: 'job-description',
    containerClassName: 'job-description-slideout',
    noOverlay: true
  },
  NOT_ACTIVE_SURVEYS: {
    component: NotActiveSurveys,
    hash: LINK_HASH_REMOVE_SURVEYS,
    containerClassName: 'not-active-surveys__slideout'
  },
  MARKETPLACE_MATCHES: {
    component: MPMSlideout,
    hash: LINK_HASH_MPM,
    containerClassName: 'marketplace-matches__mpm-slideout-container'
  },
  MARKETPLACE_MATCHES_NEW: {
    component: MarketplaceMatchesSlideoutNew,
    containerClassName: 'marketplace-matches__mpm-slideout-container'
  },
  MARKETPLACE_MATCHES_SETTINGS: {
    component: MarketplaceMatchesSettings,
    hash: LINK_HASH_MARKETPLACE_MATCHES_SETTINGS,
    containerClassName: 'marketplace-matches__settings-slideout-container'
  },
  MARKETPLACE_MATCHES_SURVEY_DETAILS: {
    component: MarketplaceMatchesSurveyDetails,
    hash: LINK_HASH_MARKETPLACE_MATCHES_SURVEY_DETAILS,
    containerClassName: 'marketplace-matches__details-slideout-container'
  },
  MPM_PURCHASE: {
    component: MPMPurchase,
    hash: LINK_HASH_MPM_PURCHASE,
    containerClassName: 'marketplace-matches__purchase-slideout-container'
  },
  STRUCTURE_BULK_COPY: {
    component: StructureBulkCopySlideout,
    hash: LINK_HASH_STRUC_BULK_COPY,
    containerClassName: 'structure-bulk-copy__slideout aspect-base'
  },
  STRUCTURE_BULK_CREATE: {
    component: StructureBulkCreateSlideout,
    hash: LINK_HASH_STRUC_BULK_CREATE,
    containerClassName: 'structure-bulk-create__slideout aspect-base'
  },
  DASHBOARD_ADD_WIDGETS: {
    component: AddWidgetsSlideout,
    hash: LINK_HASH_ADD_WIDGETS,
    containerClassName: 'dashboard-add-widgets__slideout'
  },
  CONFIGURE_VIEW: {
    component: ConfigureViewContainer,
    hash: LINK_HASH_CONFIGURE_VIEW,
    containerClassName: 'configure-view',
    disableEscape: true
  },
  JOB_EMPLOYEES: {
    component: JobEmployeesContainer,
    hash: LINK_HASH_JOB_EMPLOYEES,
    containerClassName: 'job-employees'
  },
  PRIVATE_SURVEY_JOB_MATCH: {
    component: PrivateSurveyJobMatchContainer,
    hash: LINK_HASH_PRIVATE_SURVEY_JOB_MATCH,
    containerClassName: 'private-survey-job'
  },
  REGRESSION_SURVEY_JOB_MATCH: {
    component: RegressionSurveyJobMatchContainer,
    hash: LINK_HASH_REGRESSION_SURVEY_JOB_MATCH,
    containerClassName: 'regression-survey-job'
  },
  PRIVATE_SURVEY: {
    component: PrivateSurveyContainer,
    hash: LINK_HASH_PRIVATE_SURVEY,
    containerClassName: 'private-survey'
  },
  JOB_DETAILS: {
    component: JobDetailsContainer,
    hash: LINK_HASH_JOB_DETAILS,
    containerClassName: 'job-details'
  },
  PARTICIPATION_REPORT_SLIDEOUT: {
    component: ParticipationReportSlideout,
  }
};
